const content: { [key: string]: any } = {
  userList: 'Users',
};

export default content;
